(function () {
  'use strict';

  var header = document.querySelector('[data-rsi-sh]');
  if (!header) return;

  // 2026-08-06: header is position:fixed (see assets/rsi-service-
  // header.css), removed from normal flow, so the sibling spacer
  // element has to reserve its real rendered height — measured here
  // rather than hardcoded so it stays correct across every
  // breakpoint/tier in that CSS file (and if the webfont swap changes
  // wrapped-line count on narrow viewports) without needing a second,
  // separately-maintained set of breakpoint numbers.
  var spacer = document.querySelector('[data-rsi-sh-spacer]');

  function syncSpacerHeight() {
    if (!spacer) return;
    var height = header.getBoundingClientRect().height;
    if (height > 0) {
      document.documentElement.style.setProperty('--rsi-sh-height', height + 'px');
    }
  }

  syncSpacerHeight();
  window.addEventListener('resize', syncSpacerHeight);
  window.addEventListener('orientationchange', syncSpacerHeight);

  if (window.ResizeObserver) {
    new ResizeObserver(syncSpacerHeight).observe(header);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncSpacerHeight);
  }

  var toggle = header.querySelector('[data-rsi-sh-toggle]');
  var panel = header.querySelector('[data-rsi-sh-panel]');
  var scrim = header.querySelector('[data-rsi-sh-scrim]');
  if (!toggle || !panel || !scrim) return;

  function isOpen() {
    return !panel.hasAttribute('hidden');
  }

  function openPanel() {
    panel.removeAttribute('hidden');
    scrim.removeAttribute('hidden');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('rsi-sh-nav-open');
    document.body.style.overflow = 'hidden';
  }

  function closePanel(returnFocus) {
    panel.setAttribute('hidden', 'hidden');
    scrim.setAttribute('hidden', 'hidden');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('rsi-sh-nav-open');
    document.body.style.overflow = '';
    if (returnFocus) toggle.focus();
  }

  toggle.addEventListener('click', function () {
    if (isOpen()) {
      closePanel(false);
    } else {
      openPanel();
    }
  });

  scrim.addEventListener('click', function () {
    closePanel(false);
  });

  // Close after a link inside the panel is selected.
  panel.addEventListener('click', function (event) {
    if (event.target.closest('a')) closePanel(false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) closePanel(true);
  });

  // Panel is only ever reachable via the toggle button below 1100px —
  // if the viewport grows past that (device rotation, window resize),
  // make sure it isn't left open with no visible way to close it.
  window.addEventListener('resize', function () {
    if (isOpen() && window.innerWidth >= 1100) closePanel(false);
  });
})();
